import React from "react";

const ViewCustomer = ({ customer, onClose }) => {
  if (!customer) return null;
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Customer Details</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Invoice No:</div>
                  <div className="col-8">{customer.invoiceId}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Customer Name:</div>
                  <div className="col-8">{customer.customerName}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Customer Address:</div>
                  <div className="col-8">{customer.address}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Pest Service:</div>
                  <div className="col-8">{customer.pestService || "-"}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Guarantee:</div>
                  <div className="col-8">
                    {customer.guaranteePeriod ||
                      "-"} {customer.guaranteeUnit}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Mobile Number:</div>
                  <div className="col-8">{customer.mobileNumber || "-"}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Date of Service:</div>
                  <div className="col-8">
                    {customer.dateOfService
                      ? new Date(customer.dateOfService).toLocaleDateString()
                      : "-"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Village:</div>
                  <div className="col-8">{customer.village || "-"}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">City:</div>
                  <div className="col-8">{customer.city}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">State:</div>
                  <div className="col-8">{customer.state}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 fw-bold">Amount:</div>
                  <div className="col-8">{customer.amount}</div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCustomer;
